<app-breadcrumbs [breadcrumbs]="breadcrumbs" [showHome]="false" class="d-block mb-4"></app-breadcrumbs>

<div class="row">
  <article *ngIf="order$() as order">
    <div class="float-end">
      {{ prefix + '-betaalstatus-prefix' | fromDictionary }}

      <span class="ms-2 chip-label chip--outline" [ngClass]="order.financialStatus | shopifyStatusColor : 'financial'">
        {{ getLabel('shopify-financialStatus-', order.financialStatus) }}
      </span>
    </div>
    <h2 class="mb-0">{{ prefix + '-titel' | fromDictionary }} #{{ order.orderNumber }}</h2>
    <span>{{ prefix + '-datum-prefix' | fromDictionary }} {{ order.processedAt | date : 'd MMMM y, hh:mm' : undefined : 'nl-NL' }}</span>

    <app-alert class="d-block mt-3" *ngIf="order.canceledAt" status="type--warning" [title]="prefix + '-cancel-titel' | fromDictionary">
      <p class="type-body-sm fw-normal mb-0">
        {{ prefix + '-cancel-datum-prefix' | fromDictionary }} {{ order.canceledAt | date : 'd MMMM y, hh:mm' : undefined : 'nl-NL' }}
      </p>
      <p class="type-body-sm fw-normal">{{ getLabel('shopify-OrderCancelReason-', order.cancelReason, 'Reason: ') }}</p>
    </app-alert>

    <h2 class="mt-4 h3">{{ prefix + '-status-titel' | fromDictionary }}</h2>
    <app-fulfillment-status-bar [order]="order" class="d-block my-3"></app-fulfillment-status-bar>

    <div class="mt-4">
      <ul class="order-list">
        <li class="order-list__header d-none d-md-table-row">
          <span>{{ 'label-product' | fromDictionary }}</span>
          <span class="order-list--hide-mobile">{{ 'label-SKU' | fromDictionary }}</span>
          <span class="order-list--hide-mobile">{{ 'label-prijs' | fromDictionary }}</span>
          <span class="order-list--hide-mobile">{{ 'label-aantal' | fromDictionary }}</span>
          <span>{{ 'label-totaalprijs-kort' | fromDictionary }}</span>
        </li>
        <li class="order-list__item" *ngFor="let line of order.lineItems">
          <app-order-product-list-item class="has--hover" (click)="navigateToProduct(line)" [line]="line"></app-order-product-list-item>
        </li>
      </ul>

      <div class="text-end mt-3">
        <button class="button button--secondary" type="button" (click)="openOrderAgainModal(order)">
          <span *ngIf="loadingProducts" class="icon-loader css-icon" title="laden"></span>
          <span>{{ 'order-opnieuw-bestellen-knoptekst' | fromDictionary }}</span>
        </button>
      </div>
    </div>

    <div class="row section-inset-y">
      <section class="col-12 col-lg-6">
        <h2 class="mb-3 h3">{{ prefix + '-order-details-titel' | fromDictionary }}</h2>

        <div class="card order-details">
          <div class="order-details__order">
            <h3 class="h5 fw-bold mb-1">{{ prefix + '-bestelnummer' | fromDictionary }}</h3>
            <p>#{{ order.orderNumber }}</p>

            <h3 class="h5 fw-bold mb-1">{{ prefix + '-datum-prefix' | fromDictionary }}</h3>
            <p>{{ order.processedAt | date : 'd MMMM y, hh:mm' : undefined : 'nl-NL' }}</p>
          </div>

          <div class="order-details__address">
            <h3 class="h5 fw-bold mb-1">{{ prefix + '-bezorgadres' | fromDictionary }}</h3>
            <p *ngIf="!order?.shippingAddress">{{ prefix + '-bezorgadres-niet-bekend' | fromDictionary }}</p>

            <p *ngIf="order?.shippingAddress as address">
              <span *ngIf="address.name">
                {{ address.name }}
                <br />
              </span>
              <span *ngIf="address.address1" class="d-inline-block me-1">{{ address.address1 }}</span>
              <span *ngIf="address.address2">{{ address.address2 }}</span>
              <br *ngIf="address.address1 || address.address2" />
              <span *ngIf="address.zip" class="d-inline-block me-1">{{ address.zip }}</span>
              <span *ngIf="address.city" class="d-inline-block me-1">
                <ng-container *ngIf="address.country">{{ address.city }},</ng-container>
                <ng-container *ngIf="!address.country">{{ address.city }}</ng-container>
              </span>
              <span *ngIf="address.country">{{ address.country }}</span>
              <br *ngIf="address.zip || address.city || address.country" />
              <span *ngIf="address.company">
                {{ address.company }}
                <br />
              </span>
              <span *ngIf="address.phone">{{ address.phone }}</span>
            </p>

            <!-- <h3 class="h5 fw-bold mb-1">Factuuradres</h3>
            <p>
              TODO
            </p> -->
          </div>
        </div>
      </section>

      <aside class="col-12 col-lg-6 mt-4 mt-lg-0">
        <h2 class="mb-3 h3">{{ prefix + '-kosten-overzicht-titel' | fromDictionary }}</h2>
        <div class="card order-costs">
          <ul class="order-costs__summary mb-3">
            <li class="order-costs__summary__item" *ngIf="order.subtotalPriceV2">
              <strong>{{ 'label-subtotaal' | fromDictionary }}</strong>
              <span>{{ order.subtotalPriceV2.amount | currency : order.subtotalPriceV2.currencyCode : 'symbol' : '1.2-2' }}</span>
            </li>
            <li class="order-costs__summary__item" *ngIf="order.totalTaxV2">
              <strong>{{ 'label-BTW' | fromDictionary }}</strong>
              <span>{{ order.totalTaxV2.amount | currency : order.totalTaxV2.currencyCode : 'symbol' : '1.2-2' }}</span>
            </li>
            <li class="order-costs__summary__item">
              <strong>{{ 'label-verzendkosten' | fromDictionary }}</strong>
              <span *ngIf="isFree(order.totalShippingPriceV2.amount)">{{ 'label-gratis' | fromDictionary }}</span>
              <span *ngIf="!isFree(order.totalShippingPriceV2.amount)">
                {{ order.totalShippingPriceV2.amount | currency : order.totalShippingPriceV2.currencyCode : 'symbol' : '1.2-2' }}
              </span>
            </li>
            <hr />
            <li class="order-costs__summary__item" *ngIf="order.totalPriceV2">
              <strong>{{ 'label-totaalprijs' | fromDictionary }}</strong>
              <span>{{ order.totalPriceV2.amount | currency : order.totalPriceV2.currencyCode : 'symbol' : '1.2-2' }}</span>
            </li>
          </ul>
          <!-- <a [href]="'#'" class="button button--secondary mt-3">
            <span>{{ 'naar-afrekenen-knoptekst' | fromDictionary }}</span>
          </a> -->
        </div>
      </aside>
    </div>
    <!-- <button (click)="openConfirmDialog()" class="button button--danger mt-3 float-end"><span>Order annuleren</span></button> -->
  </article>
</div>

<!-- <pre *ngIf="order$ | async as order">{{ order | json }}</pre> -->
